if (!customElements.get('adeline-review-slider')) {
  customElements.define(
    'adeline-review-slider',
    class AdelineReviewSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-review-track]');
        if (!this.track) return;

        this.cards = [...this.track.querySelectorAll('[data-review-card]')];
        this.currentIndex = 0;

        this.querySelector('[data-review-prev]')?.addEventListener('click', () => this.move(-1));
        this.querySelector('[data-review-next]')?.addEventListener('click', () => this.move(1));

        if (this.cards.length >= 3) {
          this.currentIndex = 1;
          requestAnimationFrame(() => this.scrollToIndex(1, 'auto'));
        }
      }

      move(direction) {
        if (!this.cards.length) return;
        this.currentIndex = Math.max(0, Math.min(this.currentIndex + direction, this.cards.length - 1));
        this.scrollToIndex(this.currentIndex, 'smooth');
      }

      scrollToIndex(index, behavior) {
        const card = this.cards[index];
        if (!card) return;
        const leftInset = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft - leftInset, behavior });
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-adeline-hover-menu] header-menu').forEach((menu) => {
    const details = menu.querySelector(':scope > details');
    if (!details) return;

    let closeTimer;
    const open = () => {
      window.clearTimeout(closeTimer);
      menu.closest('.header')?.querySelectorAll('header-menu > details[open]').forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
      details.setAttribute('open', '');
    };
    const close = () => {
      closeTimer = window.setTimeout(() => details.removeAttribute('open'), 140);
    };

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', close);
    menu.addEventListener('focusin', open);
    menu.addEventListener('focusout', (event) => {
      if (!menu.contains(event.relatedTarget)) close();
    });
  });
});

document.addEventListener('click', (event) => {
  const previousButton = event.target.closest('[data-adeline-upsell-prev]');
  const nextButton = event.target.closest('[data-adeline-upsell-next]');
  const button = previousButton || nextButton;
  if (!button) return;

  const upsells = button.closest('[data-adeline-upsells]');
  const track = upsells?.querySelector('[data-adeline-upsell-track]');
  const card = track?.querySelector('.adeline-cart-upsell');
  if (!track || !card) return;

  const gap = parseFloat(getComputedStyle(track).gap) || 0;
  track.scrollBy({
    left: (card.getBoundingClientRect().width + gap) * (nextButton ? 1 : -1),
    behavior: 'smooth',
  });
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-adeline-upsell-select]');
  if (!select) return;

  const option = select.selectedOptions[0];
  const card = select.closest('.adeline-cart-upsell');
  const price = card?.querySelector('[data-adeline-upsell-price]');
  const compare = card?.querySelector('[data-adeline-upsell-compare]');
  const addButton = card?.querySelector('button[name="add"]');
  const available = option?.dataset.available === 'true';

  if (price && option?.dataset.price) price.textContent = option.dataset.price;
  if (compare) {
    compare.textContent = option?.dataset.compare || '';
    compare.hidden = !option?.dataset.compare;
  }
  if (addButton) addButton.disabled = !available;
});
